var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("span", { staticClass: "caption font-weight-bold" }, [
        _vm._v("\n    " + _vm._s(_vm.label) + "\n    :\n  ")
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "caption" }, [
            _vm._v("\n    Chargement..\n  ")
          ])
        : _vm.value
        ? _c(
            "v-tooltip",
            {
              attrs: { bottom: "", color: "background" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function({ on }) {
                    return [
                      _c(
                        "v-chip",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "caption text-end",
                              attrs: { small: "" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("click", $event)
                                }
                              }
                            },
                            "v-chip",
                            _vm.$attrs,
                            false
                          ),
                          on
                        ),
                        [_vm._v("\n        " + _vm._s(_vm.value) + "\n      ")]
                      )
                    ]
                  }
                }
              ])
            },
            [_vm._v(" "), _vm._t("default")],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }